module.exports = __webpack_public_path__ + "img/0220805141437.ee8ad9ed.jpg";